import { render, staticRenderFns } from "./determineQuestion.vue?vue&type=template&id=344413f2&lang=pug"
import script from "./determineQuestion.vue?vue&type=script&lang=js"
export * from "./determineQuestion.vue?vue&type=script&lang=js"
import style0 from "./determineQuestion.vue?vue&type=style&index=0&id=344413f2&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports